import { PageType } from "~/lib/router/enums";

export const pathname = "/posties/kids";

export const page = {
  route(query: QueryParameters) {
    return { pathname, query: { ...query, pageType: PageType.PostiesKids } };
  },
};
